import React, { useState, useEffect } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { useStore } from '../../contexts/StoreContext';
import { useAuth } from '../../contexts/AuthContext';
import styles from './SideMenu.module.css';

// Icons for menu items (SVG paths)
const icons = {
  overview: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7"></rect>
      <rect x="14" y="3" width="7" height="7"></rect>
      <rect x="14" y="14" width="7" height="7"></rect>
      <rect x="3" y="14" width="7" height="7"></rect>
    </svg>
  ),
  products: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
      <line x1="3" y1="6" x2="21" y2="6"></line>
      <path d="M16 10a4 4 0 0 1-8 0"></path>
    </svg>
  ),
  categories: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="8" y1="6" x2="21" y2="6"></line>
      <line x1="8" y1="12" x2="21" y2="12"></line>
      <line x1="8" y1="18" x2="21" y2="18"></line>
      <line x1="3" y1="6" x2="3.01" y2="6"></line>
      <line x1="3" y1="12" x2="3.01" y2="12"></line>
      <line x1="3" y1="18" x2="3.01" y2="18"></line>
    </svg>
  ),
  sectors: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 3h18v18H3z"></path>
      <path d="M3 9h18"></path>
      <path d="M9 21V9"></path>
    </svg>
  ),
  settings: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"></circle>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
    </svg>
  ),
  profile: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
      <circle cx="12" cy="7" r="4"></circle>
    </svg>
  ),
  switchStore: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>
    </svg>
  ),
  requests: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <line x1="12" y1="18" x2="12" y2="12"></line>
      <line x1="9" y1="15" x2="15" y2="15"></line>
    </svg>
  ),
  advertisements: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
      <line x1="8" y1="21" x2="16" y2="21"></line>
      <line x1="12" y1="17" x2="12" y2="21"></line>
    </svg>
  ),
  locations: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
      <circle cx="12" cy="10" r="3"></circle>
    </svg>
  ),
  dashboard: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10"></line>
      <line x1="12" y1="20" x2="12" y2="4"></line>
      <line x1="6" y1="20" x2="6" y2="14"></line>
    </svg>
  ),
  allStores: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
      <polyline points="9 22 9 12 15 12 15 22"></polyline>
    </svg>
  ),
  users: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="9" cy="7" r="4"></circle>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
  )
};

interface SideMenuLink {
  path: string;
  label: string;
  icon: React.ReactNode;
}

interface SideMenuProps {
  onCollapsedChange?: (collapsed: boolean) => void;
}

const SideMenu: React.FC<SideMenuProps> = ({ onCollapsedChange }) => {
  const { selectedStore } = useStore();
  const { currentUser } = useAuth();
  const { storeId } = useParams<{ storeId: string }>();
  const [collapsed, setCollapsed] = useState(false);

  const isAdmin = currentUser?.role?.role_name?.toLowerCase() === 'admin';
  const isManager = currentUser?.role?.role_name?.toLowerCase() === 'manager';
  const isUser = currentUser?.role?.role_name?.toLowerCase() === 'user';
  const canViewProducts = isAdmin || isManager || isUser;
  const canManageCategories = isAdmin;
  const canViewSectors = isAdmin || isUser;
  const canViewStoreSettings = isAdmin || isManager;

  const storeManagementLinks: SideMenuLink[] = [
    ...(isAdmin ? [{
      path: '/dashboard',
      label: 'Dashboard',
      icon: icons.dashboard,
    }] : []),
    ...(isAdmin ? [{
      path: '/all-stores',
      label: 'All Stores',
      icon: icons.allStores,
    }] : []),
    ...(isAdmin ? [{
      path: '/all-sectors',
      label: 'All Sectors',
      icon: icons.sectors,
    }] : []),
    ...(isAdmin ? [{
      path: '/all-products',
      label: 'All Products',
      icon: icons.products,
    }] : []),
    ...(canManageCategories && selectedStore ? [{
      path: `/store/${selectedStore.id}/categories`,
      label: 'Categories',
      icon: icons.categories,
    }] : []),
    ...(isAdmin ? [{
      path: '/store-requests',
      label: 'Store Requests',
      icon: icons.requests,
    }] : []),
    ...(isAdmin ? [{
      path: '/advertisements',
      label: 'Advertisements',
      icon: icons.advertisements,
    }] : []),
    ...(isAdmin ? [{
      path: '/locations',
      label: 'Locations',
      icon: icons.locations,
    }] : []),
    ...(isAdmin ? [{
      path: '/users',
      label: 'User Management',
      icon: icons.users,
    }] : [])
  ];

  const myStoreLinks: SideMenuLink[] = selectedStore ? [
    ...(canViewSectors ? [{
      path: `/store/${selectedStore.id}/sectors`,
      label: 'Sectors',
      icon: icons.sectors,
    }] : []),
    ...(canViewProducts ? [{
      path: `/store/${selectedStore.id}/products`,
      label: 'Products',
      icon: icons.products,
    }] : []),
    ...(canViewStoreSettings ? [{
      path: `/store/${selectedStore.id}/settings`,
      label: 'Store Settings',
      icon: icons.settings,
    }] : []),
  ] : [];

  const accountLinks: SideMenuLink[] = [
    {
      path: '/profile',
      label: 'User Profile',
      icon: icons.profile,
    },
    {
      path: '/select-store',
      label: 'Switch Store',
      icon: icons.switchStore,
    }
  ];

  const toggleCollapsed = () => {
    const newCollapsedState = !collapsed;
    setCollapsed(newCollapsedState);
    if (onCollapsedChange) {
      onCollapsedChange(newCollapsedState);
    }
  };

  // Notify parent on initial render
  useEffect(() => {
    if (onCollapsedChange) {
      onCollapsedChange(collapsed);
    }
  }, [collapsed, onCollapsedChange]);

  const getLinkClass = (path: string) => {
    return ({ isActive }: { isActive: boolean }) => 
      isActive 
        ? `${styles.menuLink} ${styles.activeLink} ${collapsed ? styles.collapsedLink : ''}` 
        : `${styles.menuLink} ${collapsed ? styles.collapsedLink : ''}`;
  };

  return (
    <aside className={`${styles.sideMenu} ${collapsed ? styles.collapsedMenu : ''}`}>
      <button className={styles.collapseButton} onClick={toggleCollapsed}>
        {collapsed ? '»' : '«'}
      </button>
      
      <div className={styles.menuContent}>
        {storeManagementLinks.length > 0 && (
          <div className={styles.menuSection}>
            <h3 className={styles.menuSectionTitle}>
              {!collapsed && 'Stores Management'}
            </h3>
            <nav>
              <ul className={styles.menuList}>
                {storeManagementLinks.map((link) => (
                  <li key={link.path}>
                    <NavLink
                      to={link.path}
                      className={getLinkClass(link.path)}
                      onClick={(e) => {
                        if (link.path.startsWith('/store/') && (!selectedStore || (storeId && selectedStore.id !== parseInt(storeId,10)))) {
                          e.preventDefault();
                        }
                      }}
                      title={link.label}
                    >
                      <span className={styles.menuIcon}>{link.icon}</span>
                      {!collapsed && <span className={styles.menuLabel}>{link.label}</span>}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        )}

        {myStoreLinks.length > 0 && (
          <div className={styles.menuSection}>
            <h3 className={styles.menuSectionTitle}>
              {!collapsed && 'My Store'}
            </h3>
            <nav>
              <ul className={styles.menuList}>
                {myStoreLinks.map((link) => (
                  <li key={link.path}>
                    <NavLink
                      to={link.path}
                      className={getLinkClass(link.path)}
                      onClick={(e) => {
                        if (link.path.startsWith('/store/') && (!selectedStore || (storeId && selectedStore.id !== parseInt(storeId,10)))) {
                          e.preventDefault();
                        }
                      }}
                      title={link.label}
                    >
                      <span className={styles.menuIcon}>{link.icon}</span>
                      {!collapsed && <span className={styles.menuLabel}>{link.label}</span>}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        )}
        
        <div className={styles.menuSection}>
          <h3 className={styles.menuSectionTitle}>
            {!collapsed && 'Account'}
          </h3>
          <nav>
            <ul className={styles.menuList}>
              {accountLinks.map((link) => (
                <li key={link.path}>
                  <NavLink
                    to={link.path}
                    className={getLinkClass(link.path)}
                    title={link.label}
                  >
                    <span className={styles.menuIcon}>{link.icon}</span>
                    {!collapsed && <span className={styles.menuLabel}>{link.label}</span>}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </aside>
  );
};

export default SideMenu; 